import React, { useEffect, useState } from 'react';
import { FaEdit, FaSave } from 'react-icons/fa';
import axios from 'axios';
import "./Settings.css";

const Billing = () => {
  const vendorId = localStorage.getItem("vendorId") || "42";

  const [selectedOptions, setSelectedOptions] = useState({});
  const [editMode, setEditMode] = useState({});
  const [billingData, setBillingData] = useState(null);

  const initializeSelectedOptions = (apiData) => {
    const value = apiData.serviceCharges ?? 0;
    const typeValue = apiData.serviceChargesType;
    const applyValue = apiData.serviceChargesApply;

    setSelectedOptions({
      serviceCharges: {
        discount: value,
        type: typeValue === "CUSTOMER_PAYABLE" ? "user" : "no user",
        apply: applyValue || null,
        unit: "Percentage",
      }
    });
  };

  const handleApplyChange = (label) => {
    setSelectedOptions(prev => ({
      ...prev,
      [label]: {
        ...prev[label],
        apply: prev[label]?.apply === "Applicable" ? "Not_Applicable" : "Applicable",
      },
    }));
  };

  const fetchBillingData = async () => {
    const vendorId = localStorage.getItem("vendorId") || "42";
    const token = localStorage.getItem("authToken");

    if (!token) {
      console.warn("⚠️ No token found in localStorage.");
      return null;
    }

    try {
      const res = await axios.get(
        `https://backend.maamaas.com/food/billing/get/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setBillingData(res.data);
      initializeSelectedOptions(res.data);
      return res.data;
    } catch (err) {
      console.error("❌ Failed to fetch billing data:", err?.response?.data || err);
      return null;
    }
  };

  useEffect(() => {
    fetchBillingData();
  }, []);

  const getBillingIdByKey = () => billingData?.id || null;

  const toggleEdit = async (key) => {
    const isEdit = editMode[key];
    const token = localStorage.getItem("authToken");
    const id = getBillingIdByKey();

    if (isEdit && id) {
      const updatedData = {
        ...billingData,
        id,
        vendorId,
        serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
        serviceChargesType:
          selectedOptions.serviceCharges?.type === "user"
            ? "CUSTOMER_PAYABLE"
            : "BUSINESS_BORNE",
        serviceChargesApply: selectedOptions.serviceCharges?.apply
      };

      try {
        await axios.put(
          `https://backend.maamaas.com/food/billing/edit/${id}`,
          updatedData,
          {
            headers: {
              "Content-Type": "application/json",
              ...(token && { Authorization: `Bearer ${token}` }),
            },
          }
        );
        alert("✅ Service Charges updated successfully!");
        await fetchBillingData();
      } catch (err) {
        console.error("❌ Failed to update Service Charges:", err);
        alert("❌ Error saving changes.");
      }
    }

    setEditMode((prev) => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleOptionChange = (selectedType) => {
    setSelectedOptions(prev => ({
      ...prev,
      serviceCharges: {
        ...prev.serviceCharges,
        type: selectedType
      }
    }));
  };

  const handleDiscountChange = (value) => {
    setSelectedOptions(prev => ({
      ...prev,
      serviceCharges: {
        ...prev.serviceCharges,
        discount: value
      }
    }));
  };

  const handleSaveCharges = async () => {
    const token = localStorage.getItem("authToken");
    const requestBody = {
      ...billingData,
      id: billingData?.id || 0,
      serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
      serviceChargesType:
        selectedOptions.serviceCharges?.type === "user"
          ? "CUSTOMER_PAYABLE"
          : "BUSINESS_BORNE",
      serviceChargesApply: selectedOptions.serviceCharges?.apply
    };

    try {
      await axios.post(
        `https://backend.maamaas.com/food/billing/add/charges/${vendorId}`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        }
      );
      alert("✅ Charges saved successfully!");
    } catch (err) {
      console.error("❌ Backend error:", err?.response?.data || err);
      alert(`❌ Failed to save charges: ${err?.response?.data?.error || "Internal Server Error"}`);
    }
  };

  return (
    <div className='billingsetup' style={containerStyle}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={tableHeaderStyle}>Charge Type</th>
            <th style={tableHeaderStyle}>Customer Payable</th>
            <th style={tableHeaderStyle}>Business Borne</th>
            <th style={tableHeaderStyle}>Visibility</th>
            <th style={tableHeaderStyle}>Unit</th>
            <th style={tableHeaderStyle}>Value</th>
            <th style={tableHeaderStyle}>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tableCellStyle}><strong>Service charges</strong></td>
            <td style={tableCellStyle}>
              <input
                type="checkbox"
                checked={selectedOptions['serviceCharges']?.type === 'user'}
                onChange={() => handleOptionChange('user')}
                disabled={!editMode['serviceCharges']}
                style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
              />
            </td>
            <td style={tableCellStyle}>
              <input
                type="checkbox"
                checked={selectedOptions['serviceCharges']?.type === 'no user'}
                onChange={() => handleOptionChange('no user')}
                disabled={!editMode['serviceCharges']}
                style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
              />
            </td>
            <td style={tableCellStyle}>
              <input
                type="checkbox"
                checked={selectedOptions['serviceCharges']?.apply === 'Applicable'}
                onChange={() => handleApplyChange('serviceCharges')}
                disabled={!editMode['serviceCharges']}
                style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
              />
            </td>
            <td style={tableCellStyle}>Percentage</td>
            <td style={tableCellStyle}>
              {editMode['serviceCharges'] ? (
                <input
                  type="number"
                  placeholder="Enter value"
                  value={selectedOptions['serviceCharges']?.discount || ''}
                  onChange={(e) => handleDiscountChange(e.target.value)}
                  style={inputStyle}
                />
              ) : (
                selectedOptions['serviceCharges']?.discount || '--'
              )}
            </td>
            <td style={tableCellStyle}>
              <button
                onClick={() => toggleEdit('serviceCharges')}
                style={iconButtonStyle}
              >
                {editMode['serviceCharges'] ? <FaSave /> : <FaEdit />}
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
        <button
          onClick={handleSaveCharges}
          style={{
            background: "rgb(177 93 198)",
            color: "#fff",
            borderRadius: "10px",
            padding: "10px 20px",
            border: "none",
            cursor: "pointer"
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

// Styles
const containerStyle = {
  maxWidth: '900px',
  margin: '0 auto',
  padding: '0px',
  borderRadius: '12px',
  fontFamily: 'Segoe UI, sans-serif',
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
};

const tableHeaderStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
  fontWeight: 'bold',
  backgroundColor: '#b15cd6',
  color: 'white',
  padding: '8px',
};

const tableCellStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
  padding: '8px',
};

const inputStyle = {
  width: '100px',
  padding: '5px',
  fontSize: '14px',
  border: 'none',
  outline: 'none',
  backgroundColor: '#f7f7f7',
};

const iconButtonStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '18px',
  color: '#4A148C',
};

export default Billing;
